// Deprecated.

import { withMetadata } from '../min/metadata'

import _isValidNumber from '../es6/validate'

export function isValidNumber() {
	return withMetadata(_isValidNumber, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/isValidNumber.js
// module id = 0+TY
// module chunks = 0 1